/**
 * Templates pages
 */
(function () {

	/**
	 * Create the cookie
	 * @param {*} name Cookie name
	 * @param {*} value Cookie value
	 * @param {*} days Days the cookie shall remain active
	 */
	function createCookie(name, value, days) {
		let date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		let expires = "; expires=" + date.toGMTString();
		document.cookie = name + "=" + value + expires + "; path=/; SameSite=None; Secure";
	}

	/**
	 * Get a cookie by name
	 * @param {*} cname Cookie name
	 * @returns Cookie value
	 */
	const getCookie = (name) => {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
	}

	/**
	 * Show the form alert
	 * @param {*} form The form element
	 * @param {*} message Your message
	 */
	const formError = (form, message) => {
		// Grab the element before the form
		const alert = form.previousElementSibling;

		// Add the message to the alert
		alert.innerHTML = message;

		// Show the alert
		alert.classList.remove('hidden');
	}

	/**
	 * Submit the HS form
	 * @param {*} formData Form data
	 */
	const submitForm = (formData) => {


		// Lets build the URL to submit the form
		const url = `https://api.hsforms.com/submissions/v3/integration/submit/${formData.portalId}/${formData.formId}`;

		// Now lets grab some important information to add to the form
		const pageWrapper = document.querySelector('#primary');
		const wpTitle = pageWrapper.dataset.pageTitle;
		const isMobileRedirect = pageWrapper.dataset.mobileRedirect === '1';
		const mobilePage = pageWrapper.dataset.mobilePage;
		const userConn = pageWrapper.dataset.userConn;

		// Now lets build out the data we need to submit
		const data = {
			fields: [
				{
					objectTypeId: "0-1",
					name: "email",
					value: formData.email
				},
			],
			context: {
				pageUri: window.location.href,
				pageName: wpTitle ? wpTitle : document.title
			}
		};

		// If there is a hubspot cookie, then lets add it to the data
		if (document.cookie.includes('hubspotutk')) {
			data.context.hutk = getCookie('hubspotutk');
		}

		// If there is an ip address, then lets add it to the data
		if (userConn) {
			data.context.ipAddress = userConn;
		}

		// Convert the data to JSON
		const json = JSON.stringify(data);

		// Now lets submit the form
		fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: json,
		})
			.then(response => response.json())
			.then(data => {
				console.log('Success:', data);
				// Check the status for an error
				if (data.status === 'error') {
					formError(formData.form, data.errors[0].message);
					return;
				}


				// Now lets update our utm params if they exist
				if (document.cookie.includes('__coeff-utm2')) {
					const utmParams = getCookie('__coeff-utm2');

					// Decode the utm params
					const decodedUtmParams = JSON.parse(decodeURIComponent(utmParams));

					// If there is a utm_params object, then lets add it to the data
					if (decodedUtmParams.utm_params) {
						decodedUtmParams.utm_params.install_getstarted_url = window.location.href;
					}

					// Update the cookie
					createCookie('__coeff-utm2', encodeURIComponent(JSON.stringify(decodedUtmParams)), 7);
					console.log('UTMs updated');
				}

				// If not, lets redirect them to the redirect page on a new tab
				// window.location.href = formData.redirect;
				window.open(formData.redirect, '_blank');

				return;
			})
			.catch((error) => {
				console.error('Error:', error);
				formError(formData.form, 'There was an error submitting the form. Please try again.');
				return;
			});
	}


	const validateForm = (form, formData) => {

		// Get the modal form attribute
		const modalForm = form.dataset.modalForm;
		const button = form.querySelector('input[type="submit"]');

		// We need all of that data to be able to submit the form
		if (!formData.formId || !formData.portalId || !formData.region || !formData.modalId || !formData.email) {
			formError(form, 'Missing form data');
			return;
		}

		// Now lets quickly check if the email is valid
		if (!formData.email.includes('@')) {
			formError(form, 'Invalid email address');
			return;
		}

		// Now check if the email is gmail or yahoo
		if (formData.email.includes('@gmail') || formData.email.includes('@yahoo')) {
			// If the form is not a modal form, then we need to redirect to the modal form
			if (modalForm !== 'true') {
				// Get the modal
				const modal = document.getElementById(formData.modalId);

				// Show the modal
				modal.classList.toggle('show');

				// Get the modal form
				const modalForm = modal.querySelector('.template-hs-form');

				// Add the email to the modal form
				modalForm.dataset.nonBusinessEmail = formData.email;
			} else {
				// Change the form button to a loading state
				button.value = 'Loading...';
				button.disabled = true;

				submitForm(formData);
			}
		} else {
			// Change the form button to a loading state
			button.value = 'Loading...';
			button.disabled = true;

			submitForm(formData);
		}
	}


	// Grab all the forms on the page
	const forms = document.querySelectorAll('.template-hs-form');

	// Add the event listener to each form
	forms.forEach((form) => {
		form.addEventListener('submit', (e) => {
			e.preventDefault();

			// Now lets grab all the data attributes from the form
			const formData = {
				form: form,
				formId: form.dataset.formId,
				portalId: form.dataset.portalId,
				region: form.dataset.region,
				modalId: form.dataset.modalId,
				redirect: form.dataset.redirect,
				email: form.querySelector('input[name="email"]').value,
			};

			// Run the validate form function
			validateForm(form, formData);
		});
	});

}());
